import { render, staticRenderFns } from "./gptEdit.vue?vue&type=template&id=0aa5c6ce&scoped=true&"
import script from "./gptEdit.vue?vue&type=script&lang=js&"
export * from "./gptEdit.vue?vue&type=script&lang=js&"
import style0 from "./gptEdit.vue?vue&type=style&index=0&id=0aa5c6ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa5c6ce",
  null
  
)

export default component.exports